import { HttpService } from '@src/api/common/HttpService';
import { CTE_API_URL } from '@src/constants/BaseUrls';

type CodeType = {
  code: string | null;
};

type TokenType = {
  token: string | null;
};
const AuthenticationService = () => {
  const { HttpPost } = HttpService();
  const { HttpGet } = HttpService();
  // const PostLoginCredentials = async (body) => {
  //   const url = `${RHApiUrl}/api/v1/authentication`;
  //   const response = await HttpPost(url, body);
  //   return response;
  // };

  const SSOInitiateUrl = async () => {
    const url = `${CTE_API_URL}/api/v1/authentication/sso/initiate`;
    const response = await HttpGet(url);
    return response;
  };

  const SSOGetAccessToken = async (body: CodeType) => {
    const url = `${CTE_API_URL}/api/v1/authentication/sso/access-token`;
    const response = await HttpPost(url, body);
    return response;
  };

  const CallSSOEndPoint = async (body: TokenType) => {
    const url = `${CTE_API_URL}/api/v1/authentication/sso`;
    const response = await HttpPost(url, body);
    return response;
  };

  return {
    SSOGetAccessToken,
    SSOInitiateUrl,
    CallSSOEndPoint,
  };
};

export { AuthenticationService };
